export default {
  // Errors
  notFound: 'Inventory not found',

  // Words
  activeInventories: 'Active inventories',
  businessLicense: 'Business license',
  businessLicenseDate: 'Business license date',
  businessLicenseNo: 'Business license number',
  capacity: 'Capacity',
  cellNumber: 'Cell number',
  economicalCode: 'Economical code',
  enterInventory: 'Enter inventory',
  inventory: 'Inventory',
  inventoryActived: 'Inventory actived',
  inventoryName: 'Inventory name',
  inventoryRemoved: 'Inventory removed',
  inventorySuspended: 'Inventory suspended',
  inventoryUpdated: 'Inventory updated',
  kilogram: 'Kilogram',
  managerName: 'Manager name',
  managerNationalCode: 'Manager national code',
  nationalId: 'National ID',
  newInventoryAdded: 'New inventory added',
  operatorName: 'Operator name',
  phoneCode: 'Phone code',
  phoneNumber: 'Phone number',
  profileStatus: 'Profile status',
  suspendedInventories: 'Suspended inventories',
  valueAddedRegCert: 'Image of value added registration certificate from evat.ir site',
  workingHours: 'Working hours'
}